export const PLAYING_AGE_MIN = 3;
export const PLAYING_AGE_MAX = 99;
